import { Calculation, ExchangeDirection } from 'models/exchange-transfer-calculate'
import { CurrencyMinimalAmount, SettingsKeys } from 'models/settings'
import { Currency } from 'models/calculator'

export * from '../config'

export const SETTINGS_KEYS: SettingsKeys[] = ['currency', 'market-currency-pairs', 'direct-exchange-minimal-amounts']

export const FIXED_OPTION_LIST: ExchangeDirection[] = ['back', 'forward']

export const DEFAULT_BASE_CURRENCY = 'EUR'
export const DEFAULT_COUNTER_CURRENCY = 'PLN'
export const DEFAULT_DIRECTION: ExchangeDirection = 'forward'
export const WITHOUT_TRANSFER_FEE = true

export const DEFAULT_RESPONSE: Calculation = {
  sold_amount: '0.00',
  bought_amount: '0.00',
  exchange_amount: '0.00',
  bought_currency: DEFAULT_BASE_CURRENCY,
  sold_currency: DEFAULT_COUNTER_CURRENCY,
  average_rate: '0.0000',
  transfer_type: 'ELIXIR',
  transfer_type_fee: '0.00 PLN',
  minimal_amount: '0.00 PLN',
  fee_amount: '0.00',
  fee_percent: '0.00',
  base_currency: DEFAULT_BASE_CURRENCY,
  fee: '0.00',
}

export const DEFAULT_MINIMAL_AMOUNT: CurrencyMinimalAmount = {
  currency: DEFAULT_BASE_CURRENCY,
  minimal_local: '1',
  minimal_foreign: '1',
  minimal_wallet: '1',
}

export const PLN_MINIMAL_AMOUNT: CurrencyMinimalAmount = {
  currency: DEFAULT_COUNTER_CURRENCY,
  minimal_local: '2',
  minimal_foreign: '2',
  minimal_wallet: '2',
}

export const DEFAULT_CURRENCY: Currency = {
  symbols: [
    'EUR',
    'GBP',
    'USD',
    'CHF',
    'SEK',
    'NOK',
    'DKK',
    'CZK',
    'AUD',
    'BGN',
    'CAD',
    'CNY',
    'HKD',
    'HUF',
    'ILS',
    'JPY',
    'NZD',
    'RON',
    'SGD',
    'TRY',
    'ZAR',
    'PLN',
  ],
  symbolsSorted: [
    'PLN',
    'EUR',
    'USD',
    'CHF',
    'GBP',
    'AUD',
    'CAD',
    'CNY',
    'CZK',
    'DKK',
    'HKD',
    'HUF',
    'ILS',
    'JPY',
    'NOK',
    'NZD',
    'RON',
    'SEK',
    'SGD',
    'TRY',
    'ZAR',
  ],
  defaultCurrency: 'PLN',
}
